import { api } from './index';

export interface PurchaseOrder {
  id: string;
  poNumber: string;
  rfqId: string;
  quotationId: string;
  vendorId: string;
  vendor: {
    id: string;
    businessName: string;
    email: string;
  };
  rfq?: {
    id: string;
    rfqNumber: string;
    title: string;
  };
  status: 'DRAFT' | 'ISSUED' | 'ACKNOWLEDGED' | 'CANCELLED';
  totalAmount: number;
  currency: 'MVR' | 'USD';
  items: any; // JSON
  issuedAt?: string;
  acknowledgedAt?: string;
  issuedBy?: {
    id: string;
    fullName: string;
    email?: string;
  };
  createdAt: string;
  updatedAt: string;
}

export const poApi = {
  generateDraft: (rfqId: string, quotationId: string): Promise<PurchaseOrder> =>
    api.post(`/purchase-orders/rfq/${rfqId}/generate-po`, { quotationId }).then((res) => res.data),

  issue: (id: string): Promise<PurchaseOrder> =>
    api.post(`/purchase-orders/${id}/issue`).then((res) => res.data),

  acknowledge: (id: string): Promise<PurchaseOrder> =>
    api.post(`/purchase-orders/${id}/acknowledge`).then((res) => res.data),

  get: (id: string): Promise<PurchaseOrder> =>
    api.get(`/purchase-orders/${id}`).then((res) => res.data),

  list: (filters?: { status?: PurchaseOrder['status']; vendorId?: string; rfqId?: string }): Promise<PurchaseOrder[]> =>
    api.get('/purchase-orders', { params: filters }).then((res) => res.data),
};

